import api from '@/services/apiService';

export interface CalendarSlot {
  public_id: string;
  date: string;
  start: string;
  end: string;
  price: number;
  state: 'open' | 'booked' | 'blocked' | 'locked';
  customer_name?: string;
  phone?: string;
  payment_status?: string;
  order_number?: string;
  invoice_number?: string;
  total?: number;
  paid_amount?: number;
  remaining_amount?: number;
}

export interface CalendarField {
  slug: string;
  name: string;
  short_label: string;
  sport_name: string;
  availability_mode: 'open' | 'closed' | 'custom';
  slots: CalendarSlot[];
}

export interface CalendarData {
  grid_start: string;
  grid_end: string;
  fields: CalendarField[];
}

interface ApiEnvelope<T> {
  success: boolean;
  message: string;
  data: T;
}

export async function getBookingCalendar(
  arenaSlug: string,
  start: string,
  end: string,
  fieldSlug?: string | null,
): Promise<CalendarData> {
  const { data } = await api.get<ApiEnvelope<CalendarData>>(`/arenas/${arenaSlug}/booking-calendar`, {
    params: { start, end, field_slug: fieldSlug || undefined },
  });
  return data.data;
}

export async function updateAvailabilityMode(arenaSlug: string, fieldSlug: string, mode: string): Promise<void> {
  await api.put(`/arenas/${arenaSlug}/physical-field/${fieldSlug}/availability-mode`, { mode });
}

export async function saveSessionOpenings(
  arenaSlug: string,
  fieldSlug: string,
  openings: { date: string; time_slot_public_id: string }[],
): Promise<void> {
  await api.put(`/arenas/${arenaSlug}/physical-field/${fieldSlug}/session-openings`, { openings });
}

export async function createManualBooking(arenaSlug: string, payload: {
  team_name: string;
  phone_number: string;
  field_slug: string;
  booking_date: string;
  selected_slots: string[];
  payment_status: 'paid' | 'dp_paid' | 'unpaid';
  description?: string;
}): Promise<void> {
  await api.post(`/arenas/${arenaSlug}/internal-booking`, payload);
}

export async function markOrderPaid(arenaSlug: string, orderNumber: string): Promise<void> {
  await api.post(`/arenas/${arenaSlug}/orders/${orderNumber}/mark-paid`);
}

export async function cancelCalendarOrder(arenaSlug: string, invoiceNumber: string): Promise<void> {
  await api.post(`/arenas/${arenaSlug}/cancel-order-invoice`, {
    cancel_reason: 'Dibatalkan dari kalender booking',
  }, { params: { 'invoice-number': invoiceNumber } });
}
